export const BUS_EVENTS = {
  SHOW_ALERT: 'SHOW_ALERT',
  START_NEW_CONVERSATION: 'START_NEW_CONVERSATION',
  FOCUS_CUSTOM_ATTRIBUTE: 'FOCUS_CUSTOM_ATTRIBUTE',
  SCROLL_TO_MESSAGE: 'SCROLL_TO_MESSAGE',
  MESSAGE_SENT: 'MESSAGE_SENT',
  ON_MESSAGE_LIST_SCROLL: 'ON_MESSAGE_LIST_SCROLL',
  WEBSOCKET_DISCONNECT: 'WEBSOCKET_DISCONNECT',
  WEBSOCKET_RECONNECT: 'WEBSOCKET_RECONNECT',
  WEBSOCKET_RECONNECT_COMPLETED: 'WEBSOCKET_RECONNECT_COMPLETED',
  TOGGLE_REPLY_TO_MESSAGE: 'TOGGLE_REPLY_TO_MESSAGE',
  SHOW_TOAST: 'newToastMessage',
  NEW_CONVERSATION_MODAL: 'newConversationModal',
  INSERT_INTO_RICH_EDITOR: 'insertIntoRichEditor',
  INSERT_INTO_NORMAL_EDITOR: 'insertIntoNormalEditor',
  LEAD_ATTENDANCE_CLOSED: 'leadAttendanceClosed',
  // O FAB global (`components-next/crm/GlobalFab.vue`) cria oportunidade de QUALQUER
  // tela, então quem estiver com o board na frente precisa recarregar as colunas. Um
  // evento no barramento e não uma prop: o board pode nem estar montado.
  KANBAN_OPPORTUNITY_CREATED: 'kanbanOpportunityCreated',
  // "Um ou mais itens do kanban mudaram de estado" — etapa, funil, leitura, motivo.
  //
  // Existe porque o QUADRO e a LISTA passaram a ter fontes de dados independentes: o quadro
  // guarda as colunas em refs de MÓDULO (useKanban.js), que sobrevivem à desmontagem do
  // componente, enquanto a lista refaz o fetch a cada montagem (useKanbanList). Sem um sinal
  // no meio, mutar pela lista deixava o quadro exibindo o estado anterior até um F5 — trocar
  // de visão remonta o componente, mas o singleton continua com o dado velho.
  //
  // Separado de KANBAN_OPPORTUNITY_CREATED de propósito: o handler daquele dispara um
  // useAlert('Oportunidade criada com sucesso.'), que seria mentira depois de uma reabertura.
  //
  // O payload leva { origem: 'lista' | 'quadro' } para quem emitiu ignorar o próprio aviso:
  // as duas telas já recarregam sozinhas no fluxo que originou a mudança, e sem isso a
  // recarga aconteceria duas vezes.
  KANBAN_ITEMS_CHANGED: 'kanbanItemsChanged',
};
